import React from 'react';
import { AsperaWrapper } from '../AsperaWrapper';
/**
 * React Component
 *
 * ModalGeneric allows a basic modal that handles closing and is generic for taking in children
 *
 * @example
 * ```javascript
 * <ModalGeneric modalClose={modalInfo.callback}><p>Hello World!</p>></ModalGeneric>
 * ```
 */
export class ModalGeneric extends React.Component {
    componentWillUnmount() {
        const { modalClose } = this.props;
        modalClose({});
    }
    render() {
        const { className, children } = this.props;
        return (React.createElement(AsperaWrapper, { className: `modal-body-generic ${className ? className : ''}`, disableWrapping: true }, children));
    }
}
